import React, { useEffect, useState } from "react";

import styles from './FileRequestList.module.scss';
import { useTranslate } from "react-polyglot";
import FileUpload from "../FileUpload/FileUpload";

import Tooltip from '@mui/material/Tooltip';

function FileRequestList(props: FileRequestListProps) {
    const t = useTranslate();

    const [openItem, setOpenItem] = useState<number | undefined>(undefined);

    const [fileLineHeight, setFileLineHeight] = useState<number>(window.innerWidth > 767 ? 56 : 110);

    // Add border radius to bottom of last item and top of first item
    function getBorderRadius(key: number, inner?: boolean) {
        if (key == (props.files?.length || 0)-1) {
            return inner ? "0 0 0 0" : "0 0 6px 6px";
        } else {
            return "0 0 0 0";
        }
    }

    useEffect(() => {
        setOpenItem(undefined);
    }, [props.closeFile]);

    useEffect(() => {
        window.addEventListener("resize", () => {
            setFileLineHeight(window.innerWidth > 767 ? 56 : 110);
        });
    }, []);

    return (<>
        <fieldset className="ffe-fieldset ffe-input-group">
            { props.title != undefined ?
                <legend className="ffe-form-label ffe-form-label--block">
                    { props.title }
                </legend>
            : null }
            { props.description != undefined ?
                <div className="ffe-small-text" style={{ marginBottom: "6px" }}>
                    { props.description }
                </div>
            : null }
            <div
                className={styles.infobar}
                style={{
                    borderBottom: openItem == 1 ? "1px solid #ccc" : undefined,
                }}
            >
                <p>{t("fileupload.uploadedamount")} {props.files?.filter(i => i.data != undefined).length} / {props.files?.length}</p>
            </div>
            <div className={styles.filelist}>
                { props.files?.map((file: any, key: number) => {
                    return (
                        <div
                            key={key}
                            className={styles.file + " " + (openItem === key+1 ? styles.open : "")}
                            style={{
                                borderBottom: 
                                    ((key+1) != props.files?.length) && (openItem != key+1) && (openItem != key+2)
                                ? "none" : undefined,
                                borderRadius: getBorderRadius(key),
                                marginTop: openItem === key+1 ? "10px" : undefined,
                                marginBottom: openItem === key+1 ? "10px" : undefined,
                                maxHeight: openItem === key+1 ? "800px" : fileLineHeight + "px",
                            }}
                        >
                            <div
                                className={styles.header}
                                onClick={() => {
                                    if (openItem == key+1) {
                                        setOpenItem(undefined);
                                    } else {
                                        setOpenItem(key+1);
                                    }
                                }}
                                style={{
                                    borderRadius: getBorderRadius(key, true),
                                }}
                            >
                                <div className={styles.filestatus}>
                                    { file.status == "received" ? 
                                        <Tooltip
                                            leaveDelay={100}
                                            title={"Fil mottatt"}
                                            placement="top"
                                        >
                                            <span className={"material-symbols-outlined " + styles.completed}>check_circle</span>
                                        </Tooltip>
                                    : file.status == "requested" ?
                                        <Tooltip
                                            leaveDelay={100}
                                            title={"Filen mangler"}
                                            placement="top"
                                        >
                                            <span className={"material-symbols-outlined " + styles.missing}>error</span>
                                        </Tooltip>
                                    : null }
                                </div>
                                <div className={styles.filename}>
                                    {file.name}
                                </div>
                                <div className={styles.infotext}>
                                    { openItem != key+1 ?
                                        file.status == "received" ?
                                            file.data?.filename || ""
                                        : file.status == "requested" ?
                                            t("fileupload.clicktoupload")
                                        : null
                                    :
                                        file.status == "received" ?
                                            file.data?.filename || ""
                                        : file.status == "requested" ?
                                            t("fileupload.selectfile")
                                        : null
                                    }
                                </div>
                            </div>
                            <div className={styles.uploadarea}>
                                <FileUpload
                                    title={file.helptitle}
                                    description={file.helpdescription}
                                    buttontext={
                                        file.status == "received" ?
                                            t("fileupload.replacefile")
                                        : file.status == "requested" ?
                                            t("fileupload.uploadfile")
                                        : null 
                                    }
                                    onChange={(fileInput: any) => {
                                        props.onFileChange?.(key, fileInput, file);
                                    }}
                                    uploadHandler={(fileInput: any) => {
                                        props.uploadHandler?.(key, fileInput, file);
                                    }}
                                ></FileUpload>
                            </div>
                        </div>
                    );
                })}
            </div>
        </fieldset>
    </>);
};

class FileRequestListProps{
    title?: string;
    description?: string;
    files?: Array<any>;
    onFileChange?: Function;
    uploadHandler?: Function;
    closeFile?: number;
}


export default FileRequestList;